/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/patricia/"

const patricia: CommunityData = {
  code: "patricia",
  inviteCode: "patricia",
  name: "Patricia",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/pat-019`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#323d97",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[174.3px] h-[20.4px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[174.3px] h-[20.4px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ebebeb",
      asideBg: "#323d97",
      asideStyles: "",
      contentBg: "#ebebeb",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background.mp4?type=video`,
      mainFont: "font-['RobotoRegular']",
      primaryButton:
        "bg-[#323d97] px-[18px] py-[18px] !text-[#ffffff] font-['OswaldSemiBold'] !text-[16px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#323d97",
      sideBarSeparator: "border-r-[1px] border-[#323d97]",
      separator: "border-[#323d97]",
      item: "font-['OswaldMedium'] text-[20px] text-[#FFF] text-left leading-[120%] gap-x-[10px] text-opacity-50 text-center border-b border-[#323d97] !pl-0 !py-3 font-['OswaldRegular'] !uppercase",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ebebeb] !pb-8",
      titles: "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['RobotoRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#323d97]",
        sectionTitle:
          "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ebebeb]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#323d97] font-['OswaldMedium'] text-[16px] text-left leading-[120%]",
          subtitle: "text-[#8d8d8d] font-['RobotoRegular'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#323d97]",
        sectionTitle:
          "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ebebeb]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#323d97] font-['OswaldMedium'] text-[16px] text-left leading-[120%]",
          subtitle: "text-[#8d8d8d] font-['RobotoRegular'] text-[14px] text-left mt-2",
          location: "text-[#8d8d8d] font-['RobotoRegular'] text-[12px] text-left mt-1",
          date: "text-[#8d8d8d] font-['RobotoRegular'] text-[12px] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#323d97] font-['OswaldRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#222222] font-['RobotoRegular'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ebebeb] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#323d97]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%]",
        subtitle: "text-[#8d8d8d] font-['RobotoRegular'] text-[14px] text-left mb-4 mt-2",
        button:
          "bg-[#323d97] border border-[#4bb641] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['OswaldSemiBold'] !text-[16px] uppercase text-left",
        questions: "text-[14px] text-left",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-[#323d97]",
        header: "text-[#323d97] font-['OswaldRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#222222] font-['RobotoRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#323d97] border-t",
        header: "text-[#323d97] font-['OswaldRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#222222] font-['RobotoRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "h-[206px] overflow-hidden border border-[#323d97] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#323d97] font-['OswaldRegular'] text-[24px] text-left leading-[120%]",
        text: "text-[#222222] font-['RobotoRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#323d97] font-['OswaldMedium'] text-[28px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-4 sm:mb-6",
        outerContainer: "flex flex-col !bg-[#ebebeb]",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ebebeb] border-b border-[#323d97] py-2 sm:py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#323d97] font-['OswaldMedium'] text-[16px] text-left leading-[120%] mb-1",
          description:
            "text-[#8d8d8d] font-['RobotoRegular'] text-[14px] text-left mb-1 flex flex-row",
          price: "text-[#8d8d8d] font-['OswaldMedium'] text-[16px] text-left leading-[120%]",
          quantity: "text-[#ffffff] font-['OswaldSemiBold'] text-[14px] uppercase text-left",
          status: "text-[#8d8d8d] font-['OswaldMedium'] text-[16px] text-left leading-[120%]",
          counterContainer: "bg-[#d03431] px-2 py-2 gap-x-4 !w-fit !h-10",
          button:
            "bg-[#d03431] px-2 py-2 text-[#ffffff] font-['OswaldSemiBold'] text-[14px] uppercase text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default patricia
